module.exports = __webpack_public_path__ + "img/FGr_Logistik_Materialwirtschaft.01d5a578.svg";